export default __webpack_public_path__ + "static/media/on-point-solar-bg.f178ea99.jpeg";